import React from 'react';
import styled from 'styled-components';
import { map, prop } from 'ramda';
import RatioImage from '../../components/common/RatioImage';
import CompanyTitle from '../../components/Detail/components/Header/components/CompanyTitle';
import Technology from '../../components/Detail/components/Header/components/Technology';
import SocialIcons from '../../components/common/SocialIcons';
import { HiringButton } from '../../components/common/Item';
import ButtonLinks from './ButtonLinks';
import { getItemById } from '../../utils';

export default ({ startupIndex, filteredList }) => {
  const projectId = filteredList[startupIndex];
  
  const project = getItemById(projectId);


  if (!project) {
    return null;
  }

  const { company, product, social } = project;
  return (
    <ModalContent>
      <ModalWrapper>
        <ImageWrapper>
          <ModalImage src={product.images.macbookMock} />
        </ImageWrapper>
        <ContentWrapper>
          <FlexTop>
            <Flex>
              <CompanyTitle {...company} />
              {prop('hiringUrl', company) && (
                <HiringButton href={prop('hiringUrl', company)}>Kariéra</HiringButton>
              )}
            </Flex>
            <Title>{product.title}</Title>
            <ProductShortDescription>{product.description}</ProductShortDescription>
            {prop('hashtags', product) && (
              <HashTagList>
                {map(item => <HashTag key={item}>#{item}</HashTag>)(product.hashtags)}
              </HashTagList>
            )}
            <ButtonLinks links={product.links} />
          </FlexTop>
          <FlexBottom>
            <Line />
            {prop('technologies', product) && <Technology items={product.technologies} />}
            <div>
              <SmallTitle>Social:</SmallTitle>
              <SocialIcons social={social} />
            </div>
          </FlexBottom>
        </ContentWrapper>
      </ModalWrapper>
    </ModalContent>
  );
};

const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 32px;
  margin-bottom: 32px;
`;

const FlexBottom = styled.div`
  & > * {
    margin: 16px 0;
  }
`;

const Line = styled.div`
  display: block;
  width: 100%;
  height: 1px;
  background: rgba(0, 0, 0, 0.07);
  margin: 16px 0;
`;

const FlexTop = styled.div`
  flex-grow: 1;
`;

const SmallTitle = styled.div`
  color: #8e9aa7;
  margin-bottom: 8px;
  font-size: 14px;
`;

const HashTag = styled.span`
  color: #8e9aa7;
  font-size: 12px;
`;

const HashTagList = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  & > *:not(:last-child) {
    margin-right: 16px;
  }
`;

const ImageWrapper = styled.div`
  width: 100%;

  @media screen and (min-width: 1000px) {
    width: 60%;
  }
`;

const ContentWrapper = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  min-height: 500px;
  display: flex;
  position: relative;

  @media screen and (min-width: 1000px) {
    max-width: 400px;
  }
`;

const ModalImage = styled(RatioImage)`
  width: 100%;
  padding-top: 75%;
  height: 100%:

`;

const ModalWrapper = styled.div`
  @media screen and (min-width: 1000px) {
    display: flex;
    justify-content: space-between;
    ${ModalImage} {
      height: 100%;
      padding-top: 0;
    }
  }
`;

const ModalContent = styled.div`
  background: white;
`;

const Title = styled.div`
  font-size: 32px;
  color: #212529;
  font-weight: bold;
  margin-bottom: 8px;
`;

const ProductShortDescription = styled.div`
  color: #6c757d;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 16px;
`;
